// ProductList.js
import React, { useCallback, useState, useEffect } from "react";
import Product from "./Product";
import ProductAdmin from "./ProductAdmin.js";
import ProductFilter from "./ProductFilter.js";
import useFilteredProducts from "../hooks/useFilteredProducts.js";
import "./productList.css";
import { socket } from "../hooks/useFilteredProducts";

const ProductList = ({ categories, admin }) => {
  const {
    productosOriginales,
    filteredProducts,
    activeCategory,
    setActiveCategory,
    searchTerm,
    setSearchTerm,
    loading,
    isClosed,
  } = useFilteredProducts();

  const [showAddForm, setShowAddForm] = useState(false);
  const [newProduct, setNewProduct] = useState({
    img: "",
    nombre: "",
    precio: "",
    presentacion: "",
    peso: "",
    categoria: categories[0],
    disponible: true,
  });

  const handleCategoryChange = useCallback(
    (category) => {
      setActiveCategory(category);
    },
    [setActiveCategory]
  );

  const handleSearchChange = (e) => {
    const inputValue = e.target.value;
    setSearchTerm(inputValue);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProduct((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddProduct = async () => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await fetch(
        "https://backend-verduleria-production.up.railway.app/api/products",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ editedProduct: newProduct }),
        }
      );
      console.log(response);

      if (!response.ok) {
        throw new Error("Error al agregar el producto");
      }

      const addedProduct = await response.json();
      setShowAddForm(false);
      setNewProduct({
        img: "",
        nombre: "",
        precio: "",
        presentacion: "",
        peso: "",
        categoria: categories[0],
        disponible: true,
      });
    } catch (error) {
      console.error("Error al agregar el producto:", error);
    }
  };

  const closeShop = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend-verduleria-production.up.railway.app/api/products/disable-all`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al cerrar");
      }
    } catch (error) {
      console.error("Error al cerrar:", error);
    }
  };
  const openShop = async () => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `https://backend-verduleria-production.up.railway.app/api/products/enable-all`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Error al abrir");
      }

      socket.emit("productosHabilitados");
    } catch (error) {
      console.error("Error al abrir:", error);
    }
  };
  return (
    <div className="productList">
      {/* Mostrar mensaje si la tienda está cerrada y no es modo admin */}
      {isClosed && !admin && !loading ? (
        <div className="closed-message">
          <p className="closed-message-text">
            ¡Hola! Estamos buscando los productos mas frescos para la proxima
            semana. Puedes hablarnos al 1512345678, la tienda volvera a estar
            disponible el lunes a las 8am, ¡Los esperamos!
          </p>
        </div>
      ) : (
        <>
          <ProductFilter
            categories={categories}
            searchTerm={searchTerm}
            activeCategory={activeCategory}
            setSearchTerm={handleSearchChange}
            setActiveCategory={handleCategoryChange}
          />
          {loading ? (
            <div className="loader-container">
              <div className="loader"></div>
              <p className="loader-text">
                Cargando tus frutas y verduras frescas...
              </p>
            </div>
          ) : (
            <>
              {admin && (
                <div className="openClosePanel">
                  <button className="abrir" type="button" onClick={openShop}>
                    Abrir Tienda
                  </button>
                  <button className="cerrar" type="button" onClick={closeShop}>
                    Cerrar Tienda
                  </button>
                </div>
              )}
              <div className="product-container">
                {admin && (
                  <div
                    className={`agregarProducto shadow text-center`}
                    onClick={() => setShowAddForm(true)}
                  >
                    <div
                      className="product-image"
                      style={{
                        backgroundImage: `url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPsAAADJCAMAAADSHrQyAAAAOVBMVEXy8vIAmQAAkQAAjgD18/QEmQf69vr49vi917vn7ukAkADk7OTk7uXH3cfI3MgQmxAAhQDv8e3a6NoIphs5AAABRklEQVR4nO3d223DMAxAUdevxE0cy9l/2CLoAGGBFLKpcwcgdKBfAuw6SZIkSZIkSZIkSZIkSZJUr3GONdZ+6D+0X2PttR/6+calDJHKku/jx6XfIvU57dPX+yb2XLGzs7Ozs7OzZ4qdnZ2dnZ2dPVPs7Ozs7Ozs7JliZ2dnZz+tfYw0h+1zaF5t9G/7PdLyDNqfS2jeIVbRLo/ShwrIX8WGlcelNrx72YdtihS0h2Ztw3oUe5D1udirx87Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OXjd2dnZ2dnZ2dnb209vXhvdt1tJ/v+8Pe1aRaeUQ9m6/3W+Bwvt1kWEH2a9req8yVtJ92lDs7Ozs7Ozs7JliZ2dnZ2dnZ88UOzs7Ozs7O3um2NnZ2dnZE9sbvhvY7r3Ilu+ENn0fVpIkSZIkSZIkSZIkSZKk8/QDtMBLsecEUwgAAAAASUVORK5CYII=)`,
                      }}
                    ></div>
                    <p>Agregar Producto</p>
                  </div>
                )}
                {showAddForm && (
                  <div className="popupOverlay">
                    <div className="popupContent">
                      <button
                        className="closeButton"
                        onClick={() => setShowAddForm(false)}
                      >
                        ✕
                      </button>
                      <h3>Agregar Nuevo Producto</h3>
                      <form>
                        <label>
                          Imagen Url:
                          <input
                            type="text"
                            name="img"
                            value={newProduct.img}
                            onChange={handleInputChange}
                            required
                          />
                        </label>
                        <label>
                          Nombre:
                          <input
                            type="text"
                            name="nombre"
                            value={newProduct.nombre}
                            onChange={handleInputChange}
                            required
                          />
                        </label>
                        <label>
                          Precio:
                          <input
                            type="number"
                            name="precio"
                            value={newProduct.precio}
                            onChange={handleInputChange}
                            required
                          />
                        </label>
                        <label>
                          Presentación:
                          <input
                            type="text"
                            name="presentacion"
                            value={newProduct.presentacion}
                            onChange={handleInputChange}
                            required
                          />
                        </label>
                        <label>
                          Peso:
                          <input
                            type="number"
                            name="peso"
                            value={newProduct.peso}
                            onChange={handleInputChange}
                          />
                        </label>
                        <label>
                          Categoría:
                          <select
                            name="categoria"
                            value={newProduct.categoria}
                            onChange={handleInputChange}
                          >
                            {categories.map((category) => (
                              <option key={category} value={category}>
                                {category.charAt(0).toUpperCase() +
                                  category.slice(1)}
                              </option>
                            ))}
                          </select>
                        </label>
                        <button type="button" onClick={handleAddProduct}>
                          Guardar
                        </button>
                      </form>
                    </div>
                  </div>
                )}
                {filteredProducts.map((producto) =>
                  admin ? (
                    <ProductAdmin key={producto.id} product={producto} />
                  ) : (
                    <Product key={producto.id} product={producto} />
                  )
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ProductList;
